type SortableVideo = { title: string; timestamp: string | null };

export const sortVideos = (a: SortableVideo, b: SortableVideo) => {
  if (!a.timestamp && !b.timestamp) {
    if (a.title < b.title) return -1;
    if (a.title > b.title) return 1;
  }
  if (!a.timestamp) return 1;
  if (!b.timestamp) return -1;
  if (a.timestamp > b.timestamp) return -1;
  if (a.timestamp < b.timestamp) return 1;
  if (a.title < b.title) return -1;
  if (a.title > b.title) return 1;
  return 0;
};

export const isYouTubeUrl = (url: string) => /youtube\.com|youtu\.be/.test(url);

export const getYouTubeVideoId = (url: string) => {
  const match = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/.exec(url);
  return match?.[2].length === 11 ? match[2] : undefined;
};
